<form [formGroup]="form">
  <div class="form-group">
    <label class="required" for="arrivedDate">Date/Time Arrived</label>
    <div class="p-inputgroup">
      <p-calendar
        [showIcon]="true"
        class="form-control"
        formControlName="arrivedDate" id="arrivedDate"
        inputId="receivedDate"
        appendTo="body"
        name="arrivedDate">
      </p-calendar>
      <time-entry
        formControlName="arrivedTime"
        [timezone]="siteTimezone"
        [displaySeconds]="false">
      </time-entry>
    </div>
    <error-block
      [field]="form.controls.arrivedDate"
      [messages]="{
        required: 'Date Arrived is required.'
      }">
    </error-block>
    <error-block
      [field]="form.controls.arrivedTime"
      [messages]="{
        required: 'Time Arrived is required.'
      }">
      </error-block>
  </div>

  <div class="form-group">
    <label class="required" for="trailerId">Trailer</label>
    <app-trailer-select
      inputId="trailerId"
      name="trailerId"
      formControlName="trailerId"
      eligibleFor="arriving"
      [siteSubinventoryId]="(_load | async)?.siteSubinventoryId"
      [carrier]="(_load | async)?.carrier">
    </app-trailer-select>
    <error-block [field]="form.controls.trailerId" [messages]="{
      required: 'Trailer is required.'
    }">
    </error-block>
  </div>

  <div class="form-buttons">
    <button pButton type="submit"
      label="Check In Load"
      [icon]="updating ? 'pi pi-spin pi-spinner' : 'pi pi-arrow-right'"
      [disabled]="updating"
      (click)="arriveLoad()"
      [ngClass]="{'p-state-disabled': !form.valid, 'p-button-success': true }">
    </button>
  </div>
</form>
